"use client";
import React, {useState} from 'react';
import { useNavigate } from "react-router-dom";

interface YearDropDownProps {
  input?: string | number
}

export default function YearDropDown(props: YearDropDownProps) {
  const navigate = useNavigate();
  const [selectedYear, setSelectedYear] = useState(parseInt(props.input + '', 10) || new Date().getFullYear());

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const year = parseInt(event.target.value, 10);
    setSelectedYear(year);
    navigate("/" + year);
  };

  const currentYear = new Date().getFullYear();
  const years = Array.from({length: currentYear - 2023 + 1}, (v, k) => k + 2023);


  return (
    <div className="yearDropDown">
      <select className="w3-input" value={selectedYear} onChange={handleChange}>
        {years.map(year => <option key={year} value={year}>{year}</option>)}
      </select>
    </div>
  );
}
